import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { RepeatableRequest } from './repeatableRequest';
import { DEFAULT_REPEAT_INTERVAL, ERepeatPolicy, MAX_REPEAT_COUNT, MAX_REPEAT_INTERVAL } from './constants';
import { pathOr } from 'ramda';
export var RepeatableRequestManager = /*#__PURE__*/function () {
  function RepeatableRequestManager() {
    _classCallCheck(this, RepeatableRequestManager);
    _defineProperty(this, "lastRequest", void 0);
  }
  return _createClass(RepeatableRequestManager, [{
    key: "start",
    value: function start(request, onError, options) {
      if (this.lastRequest && !this.lastRequest.isFinished) {
        this.lastRequest.cancel();
      }
      var repeatableRequest = new RepeatableRequest({
        repeatInterval: pathOr(DEFAULT_REPEAT_INTERVAL, ['repeatInterval'], options),
        maxRepeatInterval: pathOr(MAX_REPEAT_INTERVAL, ['maxRepeatInterval'], options),
        maxRepeatCount: pathOr(MAX_REPEAT_COUNT, ['maxRepeatCount'], options),
        repeatPolicy: pathOr(ERepeatPolicy.OnError, ['repeatPolicy'], options)
      });
      this.lastRequest = repeatableRequest;
      return repeatableRequest.start(request, onError);
    }
  }, {
    key: "cancel",
    value: function cancel() {
      if (this.lastRequest) {
        this.lastRequest.cancel();
        this.lastRequest = undefined;
      }
    }
  }]);
}();